import { DestinationStatus } from '../types';
import {
  ArchivedBadge,
  DisabledBadge,
  EnabledBadge,
  NeedsReviewBadge,
  PendingBadge,
} from 'ui/badge';

// Memoized status badge mapping for performance
const STATUS_BADGE_MAP: Record<DestinationStatus, JSX.Element> = {
  Pending: <PendingBadge>Pending</PendingBadge>,
  Archived: <ArchivedBadge>Archived</ArchivedBadge>,
  Enabled: <EnabledBadge>Enabled</EnabledBadge>,
  'Needs Review': <NeedsReviewBadge>Needs Review</NeedsReviewBadge>,
  Disabled: <DisabledBadge>Disabled</DisabledBadge>,
} as const;

// Default fallback badge for unknown status values
const DefaultBadge = <DisabledBadge>Unknown</DisabledBadge>;

export const mapStatusToBadge = (status: DestinationStatus): JSX.Element => {
  return STATUS_BADGE_MAP[status] ?? DefaultBadge;
};
